import { initialize as initGoogleAnalytics } from '../analytics';
import { isProduction } from '../env';


const init = () => {
  if (isProduction()) {
    initGoogleAnalytics();
  }
};

export default init;



// WEBPACK FOOTER //
// ./src/services/init/index.js